/* eslint-disable no-underscore-dangle */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import {Sticky, StickyContainer} from 'react-sticky';
import {downloadProducts, getInitialProducts} from '../../actions/product-page';
import PageTitle from '../common/page-title/index';
import Filters from './filters';
import Card from './card';
import ArrowButton from '../common/button-arrow';


import './styles.css';
import {isViewport} from '../../utils/client';

class ProductPage extends Component {
  renderProductCards = (products) => {
    const orderedProducts = Object.keys(products)
      .map(curr => products[curr]);

    return orderedProducts.sort((a, b) => a.__index - b.__index)
      .map(product => (
        <Col key={`product$${product.id}`} lg={3} md={4} sm={6} xs={12}>
          <Card product={product}/>
        </Col>
      ));
  };
  downloadProducts = () => {
    const {dispatch} = this.props;
    dispatch(downloadProducts());
  };
  featuredProducts = products => products.filter(product => product.attributes['special-featured']);
  notFeaturedProducts = products => products.filter(product => !product.attributes['special-featured']);

  renderFilters = (style, isSticky, indeedSticky) => {
    const newStyle = {
      ...style,
      zIndex: 1000,
      position: (isSticky && indeedSticky) ? 'fixed' : 'static',
    };

    return (
      <Row style={newStyle}>
        <Col lg={12} md={12} sm={12} xs={12}>
          <Filters isSticky={isSticky}/>
        </Col>
      </Row>
    );
  };

  stickyContainer = (length) => {
    if (isViewport('lg') && length <= 8) {
      return false;
    } else if (isViewport('md') && length <= 6) {
      return false;
    } else if (isViewport('sm') && length <= 4) {
      return false;
    } else if (isViewport('sm') && length <= 2) {
      return false;
    }

    return true;
  };

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getInitialProducts());
  }

  render() {
    const {
      fetched, products, showFocusRankWarning, showPriceMaximaWarning
    } = this.props;

    return (
      <Grid bsClass="container" fluid className="product-page">
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <PageTitle>
              Products
            </PageTitle>
          </Col>
        </Row>
        {showFocusRankWarning && (
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <p className="focus-rank-warning">
                Products eligible for STOCK IT are currently being updated. This should only take a few minutes.
                Please check back later to see your STOCK IT eligible products.
              </p>
            </Col>
          </Row>
        )}
        {showPriceMaximaWarning && (
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <p className="focus-rank-warning">
                Products eligible for PRICE IT are currently being updated. This should only take a few minutes.
                Please check back later to see your PRICE IT eligible products.
              </p>
            </Col>
          </Row>
        )}
        <StickyContainer>
          <Sticky>
            {({style, isSticky}) => (
              this.renderFilters(style, isSticky, this.stickyContainer(products.length))
            )}
          </Sticky>
          <Row className="download-products-container">
            <Col lg={12} md={12} sm={12} xs={12}>
              <ArrowButton className="pull-right" onClick={this.downloadProducts} arrow={false} submit={false}>
                Download - Stock List
              </ArrowButton>
            </Col>
          </Row>
          <Row className="card-list">
            {fetched && this.renderProductCards(this.featuredProducts(products))}
            {fetched && this.renderProductCards(this.notFeaturedProducts(products))}
            {!fetched && (<div>Loading...</div>)}
          </Row>
        </StickyContainer>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.productPage.fetching,
  fetched: state.productPage.fetched,
  products: state.productPage.products,
  filterBox: state.productPage.filterBox,
  showFocusRankWarning: state.productPage.showFocusRankWarning,
  showPriceMaximaWarning: state.productPage.showPriceMaximaWarning,
});

export default connect(mapStateToProps)(ProductPage);



// WEBPACK FOOTER //
// ./src/components/product-page/index.jsx